import artifact from '$houdini/artifacts/SetDefaultReportPrinterMutation'
import { MutationStore } from '../runtime/stores/mutation'

export class SetDefaultReportPrinterMutationStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
